import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function MarketCard({ data }) {
  const navigate = useNavigate();
  const { company } = useParams();

  const handleClick = () => {
    navigate(`/${company}/${data.type}/${data.name.replace(/ /g, '_')}`);
  };
  return (
    <div
      onClick={handleClick}
      className='market-card'
      style={{ cursor: 'pointer' }}>
      <div className='thumbnail'>
        <img
          src={data.logo ? data.logo : data.thumbnail}
          alt={data.logo ? data.logo : data.thumbnail}
        />
      </div>
      <h2 className='title'>{data.name}</h2>
      <h3 className='subtitle'>
        {data.type === 'foundation' ? data.description : data.summary}
      </h3>
      <div className='footer'>
        {`${data.type === 'foundation' ? 'Ver fundación' : 'Donar'}`}
      </div>
    </div>
  );
}
